<script lang="ts" setup>
  import { getServiceName, isCustomBranding } from '@/utils/branding';

  const logoSrc = `${window.__VITE_ENVS.BASE_URL}logo.svg`;
  const logoAlt = isCustomBranding() ? getServiceName() : 'Wiren Board';
</script>

<template>
  <RouterLink to="/">
    <img class="min-w-[160px] w-[160px]" :src="logoSrc" :alt="logoAlt" />
  </RouterLink>
</template>
